import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Error = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconContainerError = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const errorLink: string = `${styles.LinkRight} ${styles.ErrorLink} ${
    isActive ? styles.Active : ''
  }`;

  const errorIconClass = `${styles.Icon} ${styles.Error} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faExclamationTriangle}
      iconClassName={errorIconClass}
      iconContainerClassName={iconContainerError}
      textClassName={errorLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Error;
